import { useContext } from "react";
import useSWR from "swr";

import { UserContext } from "../context";
import { Fetcher as F } from "../api";

export const useReason = (url) => {
  const {
    token: { access },
  } = useContext(UserContext);

  const { data = [] } = useSWR(access && [url], F.withToken, {
    revalidateOnFocus: false,
  });

  return data;
};
